/* eslint-disable */
import store from "../../store/index";
import axios from "axios";
export default {
    name: "EditLab",
    props: { id: String },
    data() {
        return {
            baseurl: process.env.VUE_APP_Service_URL,
            selectedLabId: this.studyid,
            location: "",
            labStatus: [],
            values: {
                labCode: "",
                labName: "",
                labType: "",
                location: "",
                countryCode: "",
                isEditMode: false,
                status: "",
                studyRef: "",
                phone: "",
                fax: "",
                contactEmail: "",
                primaryContactName: "",
                primaryContactEmail: "",
                accreditation: "",
                effectiveDate: null,

            },
            showLoading: false,
            errors: [true, true],
        };
    },
    mounted() {
        console.log("id is", this.id);
        this.isEditMode = this.id != 0;

        if (this.id == 0) {
            console.log("in add lab");
            this.getStudyDetails();
            this.getAllLabStatus();
        }
        else {
            this.retrieveLabInfo();
            this.getAllLabStatus();
        }

    },
    methods: {
        async getStudyDetails() {
            const idtoken = store.getters.getIdToken;
            let studyid = store.getters.getStudyIs;
            try {
                const res = await axios.get(
                    `${this.baseurl}/management/study/getbyid?id=${studyid}`,
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                );
                this.values.studyId = res.data.studyId;
                this.values.studyRef = res.data.studyRef;
                return res;
            } catch (err) {
                console.error("Error in get study:", err);
            }
        },
        async retrieveLabInfo() {
            const idtoken = store.getters.getIdToken;
            try {
                const response = await axios.get(
                    `${this.baseurl}/management/labmaster/getbyid?id=${this.id}`,
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                );
                const data = response.data;

                if (data.effectiveDate) {
                    data.effectiveDate = data.effectiveDate.split("T")[0];
                }

                this.values = { ...data };

                this.location = data.location || "";

            } catch (err) {
                console.error("Failed to fetch lab info:", err);
            }
        },
        async addLab() {
             this.showLoading = true;
             try {
            if (this.id == 0) {
                this.saveLab();
            }
            else {
                this.editLab();
            }
        } finally {
            this.showLoading = false;
        }
        },
        async saveLab() {
            this.validate();
            if (this.errors.includes(false)) {
                 this.showLoading = false;
                return;
            }
            const idtoken = store.getters.getIdToken;
            try {
                await axios.post(
                    `${this.baseurl}/management/labmaster/createlab`,
                    this.values,
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                );
                alert(this.$t("navigations.lab created successfully"));
                this.$router.push(`/labs`);
            }  catch (err) {
                if (err.response && err.response.data && err.response.data.messages) {
                let fullMsg = err.response.data.messages[0] || "Something went wrong!";
                let shortMsg = fullMsg.includes(":") ? fullMsg.split(":")[1].trim() : fullMsg;
                shortMsg = shortMsg.split("\n")[0].trim();
                alert(shortMsg);
            } else if (err.response && err.response.data && err.response.data.detail) {
                alert(err.response.data.detail);
            } else {
                alert("An unexpected error occurred. Please try again.");
            }

        console.error("Error in save lab:", err);
    }
},
        async editLab() {
            this.validate();
            if (this.errors.includes(false)) {
                return;
            }
            const idtoken = store.getters.getIdToken;
            try {
                await axios.put(
                    `${this.baseurl}/management/labmaster/updatelab`,
                    this.values,
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                );
                alert(this.$t("navigations.lab updated successfully"));
                this.$router.push(`/labs`);
            } catch (err) {
                alert(err.response?.data?.detail || "Update failed");
            }
        },
        validate() {
            this.values.studyRef = this.values.studyRef?.replace(/ +/g, " ").trim();
            this.values.studyId = this.values.studyId?.replace(/ +/g, " ").trim();
            this.values.labCode = this.values.labCode?.replace(/ +/g, " ").trim();
            this.values.labName = this.values.labName?.replace(/ +/g, " ").trim();
            this.values.labType = this.values.labType?.replace(/ +/g, " ").trim();
            this.values.location = this.values.location?.replace(/ +/g, " ").trim();
            this.values.countryCode = this.values.countryCode?.replace(/ +/g, " ").trim();
            this.values.phone = this.values.phone?.replace(/ +/g, " ").trim();
            this.values.fax = this.values.fax?.replace(/ +/g, " ").trim();
            this.values.contactEmail = this.values.contactEmail?.replace(/ +/g, " ").trim();
            this.values.primaryContactName = this.values.primaryContactName?.replace(/ +/g, " ").trim();
            this.values.primaryContactEmail = this.values.primaryContactEmail?.replace(/ +/g, " ").trim();
            this.values.accreditation = this.values.accreditation?.replace(/ +/g, " ").trim();
            this.values.status = this.values.status?.replace(/ +/g, " ").trim();

            // this.errors[0] = this.values.studyRef !== "";
            // this.errors[1] = this.values.studyId !== "";
            this.errors[0] = this.values.labCode !== "";
            this.errors[1] = this.values.labName !== "";
        },


        async onclosed() {
            this.$router.push(`/labs`);
        },
        async clear() {
            this.values = {
                labCode: "",
                labName: "",
                labType: "",
                location: "",
                countryCode: "",
                status: "",
                studyRef: "",
            };
            this.location = "";
            this.errors = [true, true];
        },
         async getAllLabStatus() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseurl}/management/statusmaster/getall?StatusType=Lab`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.labStatus = response.data

        })
        .catch((err) => {
          console.log(err);
        });
    },
    },
};
